import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MenuFunctionalityEnum } from 'src/app/shared/components/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/components/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { VerifyCPF } from 'src/app/shared/custom-validators/cpf.validator';
import { GuideGrievanceNotificationService } from 'src/app/shared/services/API/orchestrator-patient/guide-grievance-notification.service';
import { GetListGuideGrievanceNotificationToCardPageRequest } from 'src/app/shared/services/requests/orchestrator-patient/get-list-guide-grievance-notification-to-card-page.request';
import { GrievanceNotificationStatusEnum } from 'src/app/shared/enum/hospital-document/grievance-notification-status.enum';
import { GrievanceNotificationPendingDeleteModalComponent } from './grievance-notification-pending-delete-modal/grievance-notification-pending-delete-modal.component';
import { GuideGrievanceNotificationToCardPageStruct } from 'src/app/shared/services/structs/orchestrator-patient/guide-grievance-notification-to-card-page.struct';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
    selector: 'app-grievance-notification-pending-list',
    templateUrl: './grievance-notification-pending-list.component.html',
    styleUrls: ['./grievance-notification-pending-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GrievanceNotificationPendingListComponent implements OnInit {

  @Input() menuModuleEnum: MenuModuleEnum;
  @Input() menuFunctionalityEnum: MenuModuleEnum;
  
  constructor(
    private router: Router,
    private alertService: AlertService,
    public dialog: MatDialog,
    private maskService: MaskService,
    private guideGrievanceNotificationService: GuideGrievanceNotificationService,
    private utilService: UtilService,
  ) { }
    
  // public menuFunctionalityEnum: MenuFunctionalityEnum = MenuFunctionalityEnum.classification_grievance_notification_pending;
  public grievanceNotificationStatusEnum: typeof GrievanceNotificationStatusEnum = GrievanceNotificationStatusEnum;

  public masks: Masks = this.maskService.getMasks();
  public listGrievanceNotification: GuideGrievanceNotificationToCardPageStruct[] = [];

  public isFirstLoading: boolean = true;
  public isLoading: boolean;

  public cpfOrCns: string;
  public cpf: string;
  public cns: string;
  public episode: string;
  public generationDate: string;

  public pageIndex: number = 0;
  public pageSize: number = 50;
  public fullListSize: number;

  ngOnInit(): void {
    this.isLoading = true;
    this.search();
  }

  search(){
    this.isLoading = true;

    let request: GetListGuideGrievanceNotificationToCardPageRequest = new GetListGuideGrievanceNotificationToCardPageRequest();
    request.idGrievanceNotificationStatus = this.grievanceNotificationStatusEnum.pendente;
    request.patientCpf = this.cpf;
    request.patientCns = this.cns;
    request.idModule = this.menuModuleEnum;
    request.idEpisode = this.episode ? parseInt(this.episode) : null;
    request.datetimeInclusion = this.generationDate ? this.maskService.formatStringToDate(this.generationDate) : null;
    request.page = this.pageIndex;
    this.guideGrievanceNotificationService.getPaginatedGrievanceNotifications(request).subscribe({
      next: (response)=>{
      
        if(response.isError){
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isFirstLoading = false;
          this.isLoading = false;
          return;
        }
        
        this.listGrievanceNotification = response.listGuideGrievanceNotificationToCardPage;
        this.fullListSize = response.fullSize;
        
        this.isFirstLoading = false;
        this.isLoading = false;
      },
      error: (error)=>{
        console.log(error)
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this.isFirstLoading = false;
        this.isLoading = false;
      }
    });
  }

  openDeleteModal(idGuideGrievanceNotification: number) {
    const dialogRef = this.dialog.open(GrievanceNotificationPendingDeleteModalComponent, {
      data: {
        idGuideGrievanceNotification: idGuideGrievanceNotification
      },
    });

    dialogRef.afterClosed().subscribe({
      next: result => {
        if (result && result.delete)
          this.search();
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  changePage(pageIndex: number) {
    this.pageIndex = pageIndex;
    this.search();
  }

  private timeoutKeySearch: any = null;

  onKeySearchCPF(event: any) {

    clearTimeout(this.timeoutKeySearch);
    var $this = this;

    this.timeoutKeySearch = setTimeout(function () {

      if(!$this.cpfOrCns) {
        $this.cpf = null;
        $this.cns = null;
      }
      else {
        if ($this.cpfOrCns.replace(/[^0-9]/g, '').replace(' ', '').length <= 11) {
          $this.cpf = $this.cpfOrCns.replace(/[^0-9]/g, '').replace(' ', '');
          if (!$this.utilService.validatorCpf($this.cpf)) {
            $this.alertService.show('Erro', "valor inválido", AlertType.error);
            return;
          }
        }
        else {
          $this.cns = $this.cpfOrCns.replace(/[^0-9]/g, '').replace(' ', '');
          if (!$this.utilService.validatorCns($this.cns)) {
            $this.alertService.show('Erro', "valor inválido", AlertType.error);
            return;
          }
          $this.cns = $this.cpfOrCns.replace(/[^0-9]/g, '').replace(' ', '');
        }
      }

      if (event.keyCode != 13){
        $this.pageIndex = 0;
        $this.search();
      }
    }, 1000);
  }

  onKeySearchEpisode(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.pageIndex = 0;
        $this.search();
      }
    }, 1000);
  }
  
  onKeySearchGenerationDate(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {

      if(!$this.generationDate) {
        $this.generationDate = null;
      } else if (!$this.utilService.validatorDate($this.generationDate)) {
        $this.alertService.show('Erro', "valor inválido", AlertType.error);
        return;
      }

      if (event.keyCode != 13) {
        $this.pageIndex = 0;
        $this.search();
      }
    }, 1000);
  }

  goGrievanceNotification(item) {
    if(this.menuModuleEnum == MenuModuleEnum.classification) {
      this.router.navigate(['/classification/grievance-notification', {idGuideGrievanceNotification: item.idGuideGrievanceNotification, idEpisode: item.idEpisode}]);

    } else if (this.menuModuleEnum == MenuModuleEnum.basic_care){
      this.router.navigate(['/basic-care/grievance-notification', {idGuideGrievanceNotification: item.idGuideGrievanceNotification, idEpisode: item.idEpisode}]);
    }
  }
}
